import type { BookmarkNode } from '../types';

interface Props {
  root: BookmarkNode;
  visible: boolean;
  onOpen: (url: string) => void;
  onOpenManager: () => void;
}

export function BookmarksBar({ root, visible, onOpen, onOpenManager }: Props) {
  if (!visible) return null;
  const items = root.children || [];
  return (
    <div className="bookmarks-bar" aria-label="Bookmarks bar">
      {items.slice(0, 14).map((item) => item.type === 'bookmark' ? (
        <button key={item.id} className="bookmark-pill" onClick={() => item.url && onOpen(item.url)} title={item.url}>
          <img src={item.favicon || '/icons/mark-circle.png'} alt="" className="favicon" /> {item.title}
        </button>
      ) : (
        <details key={item.id} className="bookmark-folder-pill">
          <summary>▾ {item.title}</summary>
          <div className="bookmark-menu">
            {(item.children || []).map((child) => child.type === 'bookmark' ? (
              <button key={child.id} onClick={() => child.url && onOpen(child.url)}>{child.title}</button>
            ) : <span key={child.id} className="folder-label">{child.title}</span>)}
          </div>
        </details>
      ))}
      <button className="bookmark-pill muted" onClick={onOpenManager}>Manage…</button>
    </div>
  );
}
